import { Field } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  pushToParams,
  requestTo
} from "../../components/action-buttons/ActionButtonGenerator";
import { Accordion, Card } from "react-bootstrap";
import Filters from "../../components/list/Filters";
import CrudMain from "../../components/crud/CrudMain";
import FormikForm from "../../components/crud/FormikForm";
import Select from "../../components/form-fields/Select";
import TextInput from "../../components/form-fields/TextInput";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import FileUpload from "../../components/fields/FileUpload";
import { useTranslation } from 'react-i18next';                   /* Added Line */
import MultiSelect from "../../components/form-fields/MultiSelect";
import { formatListWithParameter } from "../../utils";

export default function Departments() {
  const [showModal, setShowModal] = useState(false);
  const [configData, setConfigData] = useState(null);
  const [refreshList, setRefreshList] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [t, i18n] = useTranslation();         /* Added Line */
  const [filters, setFilters] = useState([]);
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState("filter");
  
  const validationSchema = yup.object({
  });

  const arrangeBeforePersist = (values) => {
    let payload = {
      nameEn: values.nameEn,
      nameTr: values.nameTr,
      sorumluId: values.sorumluId,
      id: values.id,
      stId: values.stId || 90,
      departmanYetkilileriConfig: values.sirketIciYetkili?.map(siy => {
        return {
          value: siy
        }
      })
    };
    return payload;
  };

  const adaptDataForUpdate = (data) => {
    let adaptedData = {
      nameTr: data.nameTr,
      nameEn: data.nameEn,
      sorumluId: data.sorumluId,
      id: data.id,
      stId: data.stId,
      sirketIciYetkili: data.departmanYetkilileriConfig?.map(dy => dy.value)
    };
    setInitialValues(adaptedData);
  };

  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };

  const onAddButtonClicked = () => {
    setShowModal(true);
    setIsUpdating(false);
    setInitialValues({});
  };

  return (
    <Main>
      <div className={"row"}>
        <div className="col-md-12">
          <Accordion
            className="accordion accordion-rounded-stylish accordion-bordered"
            defaultActiveKey="filter"
          >
            <div className="accordion__item" key={"filter"}>
              <Accordion.Toggle
                as={Card.Text}
                eventKey={"filter"}
                className={`accordion__header ${
                  activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                } accordion__header--primary`}
                onClick={() =>
                  setActiveIndicatorInLeftPosition(
                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                  )
                }
              >
                <span className="accordion__header--icon"></span>
                <span className="accordion__header--text">
                  {t("sozlesmeler.filtreleme")}
                </span>
                <span className="accordion__header--indicator"></span>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey={"filter"}
                className="accordion__body"
              >
                <div className="accordion__body--text">
                  <Filters
                    configPointUrl="department/config"
                    // configParameterName="talepTurId"
                    // configParameterValue={16}
                    //configReqType={"POST"}
                    setConfigData={(data) => setConfigData(data)}
                    setRefreshList={setRefreshList}
                    refreshList={refreshList}
                    setFilters={setFilters}
                  >
                    <Field
                      name="name"
                      label={t("documentTypes.departman")}
                      colNumber="3"
                      oper="CONTAINS_CASE_AND_ACCENT_INSENSITIVE"
                      component={TextInput}
                    />
                  </Filters>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <CrudMain
            onAddButtonClicked={onAddButtonClicked}
            showModal={showModal}
            setShowModal={setShowModal}
            title="Departman"
            hideNewAddButton
            unscrollable
          >
            <FormikForm
              isUpdating={isUpdating}
              entityId={selectedRow && selectedRow.id}
              entityFetchId="id"
              endPointUrl="department/create"
              fetchPointUrl="department/find"
              editPointUrl="department/update-person"
              configPointUrl="department/config"
              arrangeBeforePersist={arrangeBeforePersist}
              adaptDataForUpdate={adaptDataForUpdate}
              setConfigData={(data) => setConfigData(data)}
              initialValues={initialValues}
              validationSchema={validationSchema}
              closeModal={() => setShowModal(false)}
              refreshList={() => setRefreshList(!refreshList)}
            >
              <Field
                name="nameTr"
                label={`${t("demandList.departmanAdi")} (Türkçe)`}
                colNumber="12"
                component={TextInput}
                required={true}
                validate={(value) => {
                  if (value === null || value === "") {
                    return t("validationMessages.required");
                  }
                }}
              />
              <Field
                name="nameEn"
                label={`${t("demandList.departmanAdi")} (İngilizce)`}
                colNumber="12"
                component={TextInput}
                required={true} 
                validate={(value) => {
                  if (value === null || value === "") {
                    return t("validationMessages.required");
                  }
                }}
              />
              <Field
                name="sorumluId"
                label={`${t("demandList.yetkiliKisi")}`}
                colNumber="12"
                component={Select}
                options={configData && configData.yetkiliKisi.map(u => { return { value: u.id, label: u.fullName } })}
              />
              <Field
                name="sirketIciYetkili"
                label={`${t("demandList.sirketIciYetkili")}`}
                colNumber="12"
                component={MultiSelect}
                options={configData && configData.sirketIciYetkililer.map(u => { return { value: u.id, label: u.fullName } })}
              />
            </FormikForm>
          </CrudMain>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName="grup-şirketleri"
            endpoint="department/list"
            keyField="id"
            refreshList={refreshList}
            columns={[
              {
                dataField: "id",
                text: "ID",
                sort: true,
                headerClasses: "id-header"
              },
              {
                dataField: "name",
                text: `${t("demandList.departmanAdi")}`,
                sort: true,
              },
              {
                dataField: "departmanYetkilileriConfig",
                text: `${t("demandList.sirketIciYetkili")}`,
                sort: true,
                formatter: (data) => formatListWithParameter(data,"label")
              },
            ]}
            customBody={{
              filters: filters,
            }}
            actionButtonsObject={{
              actions: [
                pushToParams(ABT.EDIT, onUpdateButtonClicked),
              ],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  );
}
